import React from "react";
import {connect} from "react-redux";
import BsDataTable from "components/data-table/BsDataTable";
import BsTabPanel from "components/panel/BsTabPanel";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import PagePermission from "components/permission/PagePermission";
import {ADMIN} from "core/utils/permissions";
import RentalRatesPaymentsFilters from "./RentalRatesPaymentsFilters";
import buildRentalPaymentsTable from "./rental-rates-payments-table";
import {fetchRentalPaymentStatistics, loadRentalPayments, exportRentalPaymentsToCsv} from "core/actions/rental-payment-actions";
import BsForm from "components/form/BsForm";
import {fetchSystemConfig} from "core/actions/system-config-actions";
import buildRentalRatesPaymentStatisticsForm from "./rental-rates-paymenr-statistics-form";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";

const queryString = require('query-string');

class RentalRatesPaymentsTab extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        name: query.name != null ? query.name : '',
        dateFrom: query.dateFrom != null ? query.dateFrom : null,
        dateTo: query.dateTo != null ? query.dateTo : null
      }
    };

    this.onLoadData(query);
    this.props.fetchRentalPaymentStatistics(this.props.match.params.systemId);
    this.props.fetchSystemConfig(props.match.params.systemId);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    if (field === 'dateFrom' || field === 'dateTo') {
      fields[field] = e.format('yyyy-MM-DD');
    } else {
      fields[field] = e.target.value;
    }

    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.name = this.state.fields.name;
    params.dateFrom = this.state.fields.dateFrom;
    params.dateTo = this.state.fields.dateTo;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.name;
    delete params.dateFrom;
    delete params.dateTo;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        name: '',
        dateFrom: '',
        dateTo: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadRentalPayments(this.props.match.params.systemId, this.prepareQuery(query));
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    if (query.name) {
      query['client.firstName'] = query.name
      query['client.lastName'] = query.name
    }

    return query
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportRentalPaymentsToCsv(this.props.match.params.systemId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/system/' + this.props.match.params.systemId + '/rental-rate-payment-info/' + row.id)
  }

  render() {
    if (this.props.systemConfig) {
      return (
        <BsTabPanel>
          <PagePermission anonymous={false} permission={ADMIN}/>
          <BsPanelLoader show={this.props.loading}/>

          <div className="bs-form-container general-settings payment_statistics">
            <BsForm
              config={buildRentalRatesPaymentStatisticsForm(this.props.systemConfig.collectTax)}
              formData={this.props.statistics}
              disabled={true}/>
          </div>

          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="outlined" type="button" onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            }>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <RentalRatesPaymentsFilters fields={this.state.fields}
                                        onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={buildRentalPaymentsTable(this.props.systemConfig.collectTax)}
                       content={this.props.payments}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
      )
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    systemConfig: state.systemConfig.systemConfig,
    payments: state.rentalPayment.rentalPayments,
    statistics: state.rentalPayment.statistics,
    loading: state.rentalPayment.loading && state.rentalPayment.loadingStatistics
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadRentalPayments: (systemId, query) => {
      dispatch(loadRentalPayments(systemId, query));
    },
    exportRentalPaymentsToCsv: (systemId, query) => {
      dispatch(exportRentalPaymentsToCsv(systemId, query));
    },
    fetchRentalPaymentStatistics: (systemId) => {
      dispatch(fetchRentalPaymentStatistics(systemId));
    },
    fetchSystemConfig: (systemId) => {
      dispatch(fetchSystemConfig(systemId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentalRatesPaymentsTab);
